import { Component } from '@angular/core';
import { AnalyticsService } from 'src/app/private/services/analytics.service';
import { UsersService } from 'src/app/private/services/users.service';
import { LeadService } from 'src/app/private/services/lead.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { MultiLineChartComponent } from "../../components/analytics/multi-line-chart/multi-line-chart.component";
import { LeadTimeChartComponent } from "../../components/analytics/lead-time-chart/lead-time-chart.component";
import { LeadActivityChartComponent } from "../../components/analytics/lead-activity-chart/lead-activity-chart.component";
import { PieChartComponent } from "../../components/analytics/pie-chart/pie-chart.component";

@Component({
  selector: 'app-analytics',
  imports: [SharedModule, MultiLineChartComponent, LeadTimeChartComponent, LeadActivityChartComponent, PieChartComponent],
  templateUrl: './analytics.component.html',
  styleUrl: './analytics.component.scss'
})
export class AnalyticsComponent {
  tabs = [
    { label: 'Leads', icon: 'pi-users' },
    {label : 'Communication', icon: 'pi-comments'}
  ];

  users: any = [];
  selectedUser: any = "";
  selectedYear: any = new Date().getFullYear().toString();
  years: any[] = ["2020", "2021", "2022", "2023", "2024", "2025"]
  isUserLoading: boolean = false;
  isAdmin: boolean = false;

  activeTabIndex = 0;
  leadLoading: boolean = false;
  leadsAnalytics: any = {};
  totalLeads: number = 0;
  pipelineStages: any[] = [];
  selectedPipelineId: number | null = null;
  isPipelineLoading: boolean = false;
  defaultPipelineStages: any[] = [];


  leadsCards = [
    {
      title: 'Total Leads',
      icon: 'pi-users',
      value: this.leadsAnalytics?.total_leads
    },
    {
      title: 'Raw Leads',
      icon: 'pi-database',
      value: this.leadsAnalytics?.raw_leads
    },
    {
      title: 'Qualified Leads',
      icon: 'pi-inbox',
      value: this.leadsAnalytics?.qualified_leads
    },
    {
      title: 'Unqualified Leads',
      icon: 'pi-clock',
      value: this.leadsAnalytics?.unqualified_leads
    },
    {
      title: 'Working Leads',
      icon: 'pi-calendar',
      value: this.leadsAnalytics?.working_leads
    },
    {
      title: 'Assigned Leads',
      icon: 'pi-users',
      value: this.leadsAnalytics?.assigned_leads
    }
  ];


  constructor(
    private localStorage: LocalStorageService,
    private api: AnalyticsService,
    private userApi: UsersService,
    private leadApi: LeadService
  ) {
    this.isAdmin = this.localStorage.isAdminUser();
  }

  ngOnInit() {
    this.loadPipelineStages();
    this.fnGetLeadAnalytics();
    this.getAllUsers();

    // append current year to years array
    const currentYear = new Date().getFullYear();
    if (!this.years.includes(currentYear.toString())) {
      this.years.push(currentYear.toString());
    }

  }

    getAllUsers() {
    const param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.userApi.findAllUsers(param).subscribe({
      next: (res: any) => {
        
        this.users = (res || []).map((user: any) => {
          return {
            ...user,
            name: [user.fname, user.last_name].join(' '),
            id: user.user_id
          };
        });

        // starting unshift with "All Users" option
        if (this.isAdmin) {
          this.users.unshift({ name: 'All Users', id: '' });
        }
        this.isUserLoading = false;
      },
      error: (e: any) => {
        console.error(e);
        this.isUserLoading = false;
      },
    });
  }


  handleTabChange(index: number) {
    this.activeTabIndex = index;
    // this.fnChangeTab(index === 0 ? 'lead' : 'deals');
  }

  fnChangeUser(event: any) {
    this.selectedUser = event;
    this.fnGetLeadAnalytics();
    // this.fnGetDealsAnalytics();
  }


  fnChangeYear(event: any) {
    this.selectedYear = event;
    this.fnGetLeadAnalytics();
    // this.fnGetDealsAnalytics();
  }




  fnGetLeadAnalytics() {

    let param: any = {
      organization_id: this.localStorage.getOrganizationId(),
      year: JSON.stringify(new Date().getFullYear()),
    }

    if (!this.isAdmin) {
      param.user_id = this.localStorage.getUserId();
    }

    if (this.selectedUser && this.selectedUser != "") {
      param.user_id = this.selectedUser;
    }

    if (this.selectedYear && this.selectedYear != "") {
      param.year = this.selectedYear;
    }

    this.leadLoading = true;
    this.api.getLeadAnalytics(param).subscribe({
      next: (res) => {
        if (res) {

          this.leadsAnalytics = res;
          // console.log(this.leadsAnalytics)
          this.leadLoading = false;
          this.totalLeads = res.total_leads
          this.leadsCards = [
            {
              title: 'Total Leads',
              icon: 'pi-users',
              value: this.leadsAnalytics?.total_leads
            },
            {
              title: 'Raw Leads',
              icon: 'pi-database',
              value: this.leadsAnalytics?.raw_leads
            },
            {
              title: 'Qualified Leads',
              icon: 'pi-inbox', 
              value: this.leadsAnalytics?.qualified_leads
            },
            {
              title: 'Unqualified Leads',
              icon: 'pi-clock',
              value: this.leadsAnalytics?.unqualified_leads
            },
            {
              title: 'Working Leads',
              icon: 'pi-calendar',
              value: this.leadsAnalytics?.working_leads
            },
            {
              title: 'Assigned Leads',
              icon: 'pi-users',
              value: this.leadsAnalytics?.assigned_leads
            }
          ];
          
          // Apply default pipeline stages if they are loaded
          if (this.defaultPipelineStages.length > 0) {
            this.updateLeadStatusFromPipeline(this.defaultPipelineStages);
          }
        }
      },
      error: (e) => {
        this.leadLoading = false;
        this.leadsAnalytics = {
          "platform_wise_leads": {
            "tina": {
              "Mar": 0,
              "Feb": 0,
              "Jan": 0,
              "Dec": 0,
              "Nov": 0,
              "Oct": 0,
              "Sep": 0,
              "Aug": 0,
              "Jul": 0,
              "Jun": 0,
              "May": 0,
              "Apr": 0
            },
            "manual": {
              "Mar": 0,
              "Feb": 0,
              "Jan": 0,
              "Dec": 0,
              "Nov": 0,
              "Oct": 0,
              "Sep": 0,
              "Aug": 0,
              "Jul": 0,
              "Jun": 0,
              "May": 0,
              "Apr": 0
            },
            "whatsapp": {
              "Mar": 0,
              "Feb": 0,
              "Jan": 0,
              "Dec": 0,
              "Nov": 0,
              "Oct": 0,
              "Sep": 0,
              "Aug": 0,
              "Jul": 0,
              "Jun": 0,
              "May": 0,
              "Apr": 0
            }
          },
          "leads_types": {
            "Hot Leads": "0",
            "Cold Leads": "0",
            "Warm Leads": "0",
            "New Leads": "0"
          },
          "leads_status": {
            "Completed": "0",
            "Follow Up": "0",
            "Communicated": "0",
            "Pending": "0"
          },
          "total_leads": "0",
          "completed_leads": "0",
          "pending_leads": "0",
          "communicated_leads": "0",
          "followup_leads": "0"
        };
      }
    })
  }

  loadPipelineStages() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      pipeline_type: 'lead'
    };
    this.isPipelineLoading = true;
    this.leadApi.getAllPipelines(param).subscribe({
      next: (res: any) => {
        if (res && res.length > 0) {
          const defaultPipeline = res.find((pipeline: any) => pipeline.set_default === true);
          if (defaultPipeline) {
            this.selectedPipelineId = defaultPipeline.id;
            this.defaultPipelineStages = defaultPipeline.stages;
            // Apply default pipeline stages if analytics data is already loaded
            if (this.leadsAnalytics && this.leadsAnalytics.leads_status) {
              this.updateLeadStatusFromPipeline(defaultPipeline.stages);
            }
          }
          this.pipelineStages = res.map((pipeline: any) => ({
            label: pipeline.pipeline_name,
            value: pipeline.id,
            stages: pipeline.stages
          }));
        }
        this.isPipelineLoading = false;
      },
      error: (e: any) => {
        console.error('Error loading pipeline stages:', e);
        this.isPipelineLoading = false;
      },
    });
  }

  onPipelineChange(event: any) {
    const selectedPipeline = this.pipelineStages.find(p => p.value === event.value);
    if (selectedPipeline && selectedPipeline.stages) {
      this.updateLeadStatusFromPipeline(selectedPipeline.stages);
    }
  }

  updateLeadStatusFromPipeline(stages: any[]) {
    // Create a new leads_status object based on pipeline stages
    const newLeadsStatus: any = {};
    stages.forEach((stage: any) => {
      newLeadsStatus[stage.stage_name] = this.leadsAnalytics?.leads_status?.[stage.stage_name] || "0";
    });
    this.leadsAnalytics.leads_status = newLeadsStatus;
  }
}
